import {
  REQUEST_MONITORING_TASK_TRIPS,
  RESPONSE_MONITORING_TASK_TRIPS,
  REQUEST_MONITORING_TASK_TRIPS_FAILURE,
  ON_SET_SEARCH_MONITORING_TASK_TRIPS,
  REQUEST_MONITORING_TASK_TRIP,
  RESPONSE_MONITORING_TASK_TRIP,
  REQUEST_MONITORING_TASK_TRIP_FAILURE,
  REQUEST_COMPLETED_MONITORING_TASK_TRIP,
  RESPONSE_COMPLETED_MONITORING_TASK_TRIP,
  REQUEST_COMPLETED_MONITORING_TASK_TRIP_FAILURE,
  SET_MONITORING_SETTINGS_STATE,
  REQUEST_MONITORING_UNIT_ADD_TASK_TRIPS,
  RESPONSE_MONITORING_UNIT_ADD_TASK_TRIPS,
  REQUEST_MONITORING_UNIT_ADD_TASK_TRIPS_FAILURE,
  REQUEST_MONITORING_ROUTES_ADD_TASK_TRIPS,
  RESPONSE_MONITORING_ROUTES_ADD_TASK_TRIPS,
  REQUEST_MONITORING_ROUTES_ADD_TASK_TRIPS_FAILURE,
} from "../actions/logisticMonitoringsTaskTripsActions";

import { RESPONSE_RECIEVE_UNITS_LAST_STATE } from "../actions/signalRActions";

import { states as queriesStates } from "./queriesStates";

import {
  REQUEST_RECIEVE_TASK_TRIP_INFORMATIONS,
  REQUEST_STOP_RECIEVE_TASK_TRIP_INFORMATIONS,
  RESPONSE_CLOSE_CONNECTION_MAP_SIGNALR,
} from "../actions/signalRActions";

const initialState = {
  monitoringTaskTripDataStateSR: queriesStates.NOT_REQUESTED,
  monitoringTaskTripsDataState: queriesStates.NOT_REQUESTED,
  monitoringTaskTripDataState: queriesStates.NOT_REQUESTED,
  monitoringTaskTripCompletedDataState: queriesStates.NOT_REQUESTED,
  monitoringAddUnitToTaskTripDataState: queriesStates.NOT_REQUESTED,
  monitoringAddRoutesToTaskTripDataState: queriesStates.NOT_REQUESTED,
  monitoringSettingsState: { modificationType: 0, unitState: null, routeState: null, isModificating: false },
  signalRLastUpdate: new Date(),
  monitoringTaskTrips: [],
  monitoringTaskTrip: null,
  searchTerm: null,
  errors: [],
};

const logisticMonitoringTaskTripsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_RECIEVE_TASK_TRIP_INFORMATIONS: {
      return Object.assign({}, state, {
        monitoringTaskTripDataStateSR: queriesStates.REQUEST,
      });
    }

    case REQUEST_STOP_RECIEVE_TASK_TRIP_INFORMATIONS: {
      return Object.assign({}, state, {
        monitoringTaskTripDataStateSR: queriesStates.NOT_REQUESTED,
      });
    }

    case RESPONSE_CLOSE_CONNECTION_MAP_SIGNALR: {
      return Object.assign({}, state, {
        monitoringTaskTripDataStateSR: queriesStates.NOT_REQUESTED,
      });
    }

    case REQUEST_MONITORING_TASK_TRIPS: {
      return Object.assign({}, state, {
        monitoringTaskTripsDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_MONITORING_TASK_TRIPS: {
      return Object.assign({}, state, {
        monitoringTaskTripsDataState: queriesStates.READY,
        monitoringTaskTrips: action.data.taskTrips,
      });
    }
    case REQUEST_MONITORING_TASK_TRIPS_FAILURE: {
      return Object.assign({}, state, {
        monitoringTaskTripsDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case ON_SET_SEARCH_MONITORING_TASK_TRIPS: {
      return Object.assign({}, state, {
        searchTerm: action.data,
      });
    }

    case RESPONSE_RECIEVE_UNITS_LAST_STATE: {
      const _monitoringTaskTrips = state.monitoringTaskTrips;

      _monitoringTaskTrips.forEach((taskTrip) => {
        taskTrip.units.forEach((unit) => {
          Object.keys(action.data).forEach((id) => {
            if (unit.id === id) {

              unit.lastState.status = action.data[id].status;
              unit.lastState.long = action.data[id].lastLocation.long;
              unit.lastState.lat = action.data[id].lastLocation.lat;
              unit.lastState.lastActive = action.data[id].lastActive;
              unit.lastState.ignition = action.data[id].ignition;
            }
          });
        });
      });

      return Object.assign({}, state, {
        signalRLastUpdate: new Date(),
        monitoringTaskTrips: _monitoringTaskTrips,
      });
    }

    case REQUEST_MONITORING_TASK_TRIP: {
      return Object.assign({}, state, {
        monitoringTaskTripDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_MONITORING_TASK_TRIP: {
      const monitoringSettingsState = state.monitoringSettingsState;
      monitoringSettingsState.isModificating = false;
      monitoringSettingsState.unitState = null;
      monitoringSettingsState.routeState = null;

      return Object.assign({}, state, {
        monitoringTaskTripDataState: queriesStates.READY,
        monitoringTaskTrip: action.data,
        signalRLastUpdate: new Date(),
        monitoringSettingsState: monitoringSettingsState,
      });
    }
    case REQUEST_MONITORING_TASK_TRIP_FAILURE: {
      return Object.assign({}, state, {
        monitoringTaskTripDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_COMPLETED_MONITORING_TASK_TRIP: {
      return Object.assign({}, state, {
        monitoringTaskTripCompletedDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_COMPLETED_MONITORING_TASK_TRIP: {
      const __monitoringTaskTrips = state.monitoringTaskTrips;

      __monitoringTaskTrips.forEach((taslTrip) => {
        taslTrip.units.forEach((unit) => {
          if (unit.taskTripId === action.data.id) {
            unit.isCompleted = true;
          }
        });
      });

      return Object.assign({}, state, {
        monitoringTaskTripCompletedDataState: queriesStates.READY,
        monitoringTaskTrips: __monitoringTaskTrips,
        signalRLastUpdate: new Date(),
      });
    }
    case REQUEST_COMPLETED_MONITORING_TASK_TRIP_FAILURE: {
      return Object.assign({}, state, {
        monitoringTaskTripCompletedDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case SET_MONITORING_SETTINGS_STATE: {
      return Object.assign({}, state, {
        signalRLastUpdate: new Date(),
        monitoringSettingsState: action.data,
      });
    }

    case REQUEST_MONITORING_UNIT_ADD_TASK_TRIPS: {
      return Object.assign({}, state, {
        monitoringAddUnitToTaskTripDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_MONITORING_UNIT_ADD_TASK_TRIPS: {
      const monitoringTaskTrip = state.monitoringTaskTrip;

      if (monitoringTaskTrip.taskTripModifications === undefined) monitoringTaskTrip.taskTripModifications = [];
      monitoringTaskTrip.taskTripModifications = monitoringTaskTrip.taskTripModifications.concat(action.data);

      const monitoringSettingsState = state.monitoringSettingsState;
      monitoringSettingsState.isModificating = true;

      return Object.assign({}, state, {
        monitoringAddUnitToTaskTripDataState: queriesStates.READY,
        monitoringTaskTrip: monitoringTaskTrip,
        monitoringSettingsState: monitoringSettingsState,
        signalRLastUpdate: new Date(),
      });
    }
    case REQUEST_MONITORING_UNIT_ADD_TASK_TRIPS_FAILURE: {
      return Object.assign({}, state, {
        monitoringAddUnitToTaskTripDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_MONITORING_ROUTES_ADD_TASK_TRIPS: {
      return Object.assign({}, state, {
        monitoringAddRoutesToTaskTripDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_MONITORING_ROUTES_ADD_TASK_TRIPS: {
      const monitoringTaskTrip = state.monitoringTaskTrip;

      if (monitoringTaskTrip.taskTripModifications === undefined) monitoringTaskTrip.taskTripModifications = [];
      monitoringTaskTrip.taskTripModifications = monitoringTaskTrip.taskTripModifications.concat(action.data);

      const monitoringSettingsState = state.monitoringSettingsState;
      monitoringSettingsState.isModificating = true;

      return Object.assign({}, state, {
        monitoringAddRoutesToTaskTripDataState: queriesStates.READY,
        monitoringTaskTrip: monitoringTaskTrip,
        monitoringSettingsState: monitoringSettingsState,
        signalRLastUpdate: new Date(),
      });
    }
    case REQUEST_MONITORING_ROUTES_ADD_TASK_TRIPS_FAILURE: {
      return Object.assign({}, state, {
        monitoringAddRoutesToTaskTripDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    default:
      return state;
  }
};

export default logisticMonitoringTaskTripsReducer;
